import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/**
 * Footer:
 *  - Footer for Question Component
 */
export function Footer(props) {
  const className = `${style.footer} ${props.className}`;
  return <div className={className}>{props.children}</div>;
}

Footer.propTypes = {
  /**
   * List of components to display in side this.
   */
  children: PropTypes.array,
  /**
   * ClassName for the Footer
   */
  className: PropTypes.string,
};

Footer.defaultProps = {className: '', children: null};
